module.exports = __webpack_public_path__ + "img/planeta-zana-merciluta.6dba277f.png";